import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMail = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_3691_61102)",
		children: [/* @__PURE__ */ _jsx("path", {
			d: "M9.99974 19.6206C4.68629 19.6206 0.378906 15.3132 0.378906 9.99974C0.378906 4.68629 4.68629 0.378906 9.99974 0.378906C15.3132 0.378906 19.6206 4.68629 19.6206 9.99974C19.6206 15.3132 15.3132 19.6206 9.99974 19.6206Z",
			stroke: "#565CDE",
			strokeWidth: .758342,
			strokeMiterlimit: 10
		}), /* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip1_3691_61102)",
			children: [/* @__PURE__ */ _jsx("path", {
				d: "M13.7501 5.625H6.25012C5.9186 5.625 5.60066 5.7567 5.36624 5.99112C5.13182 6.22554 5.00012 6.54348 5.00012 6.875V7.125L10.0001 9.9375L15.0001 7.1875V6.875C15.0001 6.54348 14.8684 6.22554 14.634 5.99112C14.3996 5.7567 14.0816 5.625 13.7501 5.625Z",
				fill: "#565CDE"
			}), /* @__PURE__ */ _jsx("path", {
				d: "M9.68762 11.1875L5.00012 8.5625V13.125C5.00012 13.4565 5.13182 13.7745 5.36624 14.0089C5.60066 14.2433 5.9186 14.375 6.25012 14.375H13.7501C14.0816 14.375 14.3996 14.2433 14.634 14.0089C14.8684 13.7745 15.0001 13.4565 15.0001 13.125V8.5625L10.3126 11.1875C10.2141 11.2308 10.1077 11.2531 10.0001 11.2531C9.89254 11.2531 9.78612 11.2308 9.68762 11.1875Z",
				fill: "#565CDE"
			})]
		})]
	}), /* @__PURE__ */ _jsxs("defs", { children: [/* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_3691_61102",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 20,
			height: 20,
			fill: "white"
		})
	}), /* @__PURE__ */ _jsx("clipPath", {
		id: "clip1_3691_61102",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 10,
			height: 10,
			fill: "white",
			transform: "translate(5.00012 5)"
		})
	})] })]
});
export default SvgMail;
